const e={defaultProps:{dense:!0}};export{e as default};
